import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWA, useLoad, useDebounced, PageHead, Card, Tabs, Search, Btn, Badge, Modal, Drawer, Pager, Skeleton, Empty, ErrorBox, Avatar, Stat, num, money, fdate, fdt, ago, exportCsv } from "../ui";
import { siteLink } from "../api";

/* Website → Admin Manager Program: applications from ycnp.in/admin-manager */

const TAKE = 30;
const TABS = [["PENDING", "Pending"], ["APPROVED", "Approved"], ["REJECTED", "Refund बाकी"], ["REFUNDED", "Refunded"], ["ALL", "सभी"]];
const TONE = { PENDING: "amber", APPROVED: "green", REJECTED: "red", REFUNDED: "blue" };
const LABEL = { PENDING: "Pending", APPROVED: "Approved", REJECTED: "Rejected · refund बाकी", REFUNDED: "Refunded" };

const mask = (s, show) => (show ? String(s || "").replace(/(\d{4})(?=\d)/g, "$1 ") : "XXXX XXXX " + String(s || "").slice(-4));
const wa = (n) => {
  const d = String(n || "").replace(/\D/g, "");
  return d ? `https://wa.me/${d.length === 10 ? "91" + d : d}` : null;
};

function Info({ label, children, full }) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <p className="text-[11.5px] wa-muted">{label}</p>
      <div className="text-[13.5px] font-medium mt-0.5 break-words whitespace-pre-line">{children || <span className="wa-muted">—</span>}</div>
    </div>
  );
}

function Doc({ src, label, onOpen }) {
  if (!src) return <div className="rounded-xl border wa-line p-4 text-center text-xs wa-muted">{label}: नहीं दिया</div>;
  return (
    <button type="button" onClick={() => onOpen({ src, label })} className="group relative block w-full overflow-hidden rounded-xl border wa-line text-left">
      <img src={src} alt={label} className="h-36 w-full object-cover bg-slate-100" />
      <span className="absolute inset-x-0 bottom-0 bg-black/60 px-3 py-1.5 text-[12px] font-semibold text-white">{label}</span>
      <span className="absolute inset-0 grid place-items-center bg-black/30 text-white opacity-0 transition group-hover:opacity-100"><i className="fa-solid fa-magnifying-glass-plus text-xl" /></span>
    </button>
  );
}

function Detail({ id, onClose, onChanged }) {
  const { api, run, confirm, prompt } = useWA();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [showNo, setShowNo] = useState(false);
  const [view, setView] = useState(null);

  const load = () => {
    setErr("");
    api("managerGet", { id })
      .then(setD)
      .catch((e) => setErr(e.message));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [id]);

  const m = d && d.item;
  const act = async (action, params, msg, ask) => {
    if (ask && !(await confirm(ask))) return;
    try {
      await run(action, params, msg);
      onChanged();
      if (action === "managerDelete") onClose();
      else load();
    } catch (e) {
      /* toast */
    }
  };

  const approve = async () => {
    const note = await prompt({ title: "Approve करें", text: "User को जाने वाला message (खाली छोड़ें तो default message जाएगा)", defaultValue: "" });
    if (note !== null) act("managerUpdate", { id, op: "approve", note }, "Approved — user को message चला गया");
  };
  const reject = async () => {
    const note = await prompt({ title: "Reject का कारण", text: "यह user को दिखेगा। Fee refund होगी।", defaultValue: "Documents साफ़ नहीं हैं" });
    if (note) act("managerUpdate", { id, op: "reject", note }, "Reject हो गया — अब refund भेजें");
  };
  const refund = async () => {
    const ref = await prompt({ title: `${money(m.amount)} refund भेज दिया?`, text: "Refund का UTR / transaction ID लिखें। User को message जाएगा।", defaultValue: "" });
    if (ref) act("managerUpdate", { id, op: "refund", refundRef: ref }, "Refund दर्ज हो गया");
  };

  return (
    <Drawer
      open
      onClose={onClose}
      width={720}
      title={m ? m.fullName : "Application"}
      subtitle={m ? `${m.district}, ${m.state} · ${fdt(m.createdAt)}` : ""}
      footer={
        m && (
          <div className="flex flex-wrap gap-2 w-full">
            {m.status === "PENDING" && (
              <>
                <Btn variant="success" icon="fa-solid fa-check" onClick={approve}>Approve</Btn>
                <Btn variant="danger" icon="fa-solid fa-xmark" onClick={reject}>Reject</Btn>
              </>
            )}
            {m.status === "REJECTED" && <Btn variant="primary" icon="fa-solid fa-rotate-left" onClick={refund}>Refund भेज दिया</Btn>}
            {m.status !== "PENDING" && <Btn icon="fa-solid fa-arrows-rotate" onClick={() => act("managerUpdate", { id, op: "reopen" }, "फिर से Pending में", { title: "इसे फिर से Pending में डालें?" })}>फिर से Pending</Btn>}
            <Btn icon="fa-regular fa-note-sticky" onClick={async () => { const n = await prompt({ title: "Note / message", defaultValue: m.adminNote || "" }); if (n !== null) act("managerUpdate", { id, op: "note", note: n }, "Note save हो गया"); }}>Note</Btn>
            <span className="flex-1" />
            <Btn className="!text-rose-600" icon="fa-regular fa-trash-can" onClick={() => act("managerDelete", { id }, "Application delete हो गई", { title: "यह application हमेशा के लिए delete करें?", text: "Documents भी मिट जाएँगे।", danger: true, ok: "Delete" })}>Delete</Btn>
          </div>
        )
      }
    >
      <ErrorBox msg={err} retry={load} />
      {!m ? !err && <Skeleton rows={6} h={52} /> : (
        <div className="space-y-5">
          <div className="flex flex-wrap items-center gap-4">
            <button type="button" onClick={() => setView({ src: m.photo, label: "Photo" })} className="shrink-0">
              <img src={m.photo} alt="" className="h-20 w-20 rounded-2xl object-cover border wa-line" />
            </button>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <p className="text-lg font-bold">{m.fullName}</p>
                <Badge tone={TONE[m.status] || "gray"}>{LABEL[m.status] || m.status}</Badge>
              </div>
              <p className="text-sm wa-muted mt-0.5">{m.email}</p>
              <div className="flex flex-wrap gap-2 mt-2">
                <a href={`tel:${m.phone}`}><Btn size="sm" icon="fa-solid fa-phone">{m.phone}</Btn></a>
                {wa(m.whatsapp || m.phone) && <a href={wa(m.whatsapp || m.phone)} target="_blank" rel="noreferrer"><Btn size="sm" variant="success" icon="fa-brands fa-whatsapp">WhatsApp</Btn></a>}
                {d.user && <Link to={`/website/users?open=${d.user.id}`}><Btn size="sm" icon="fa-regular fa-user">User profile</Btn></Link>}
              </div>
            </div>
          </div>

          {m.adminNote && <p className="rounded-xl px-3 py-2 text-[13px]" style={{ background: "color-mix(in srgb, var(--wa-ink) 5%, transparent)" }}>📝 {m.adminNote}</p>}
          {m.status === "REJECTED" && <p className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-[13px] text-amber-800 dark:bg-amber-500/10 dark:text-amber-200 dark:border-amber-500/30"><i className="fa-solid fa-triangle-exclamation mr-1" /> {money(m.amount)} वापस भेजना बाकी है। भेजने के बाद "Refund भेज दिया" दबाएँ।</p>}
          {m.status === "REFUNDED" && <p className="rounded-xl border border-sky-300 bg-sky-50 px-3 py-2 text-[13px] text-sky-800 dark:bg-sky-500/10 dark:text-sky-200 dark:border-sky-500/30">Refund भेजा {fdate(m.refundedAt)} · Ref <b className="font-mono">{m.refundRef}</b></p>}

          <Card title="Payment" icon="fa-solid fa-indian-rupee-sign">
            <div className="grid sm:grid-cols-[1fr_160px] gap-4 items-start">
              <div className="grid grid-cols-2 gap-4">
                <Info label="रकम"><b>{money(m.amount)}</b></Info>
                <Info label="UTR"><span className="font-mono select-all">{m.utr}</span></Info>
                <Info label="भेजा">{fdt(m.createdAt)}</Info>
                <Info label="देखा">{m.reviewedAt ? fdt(m.reviewedAt) : "अभी नहीं"}</Info>
              </div>
              <Doc src={m.payProof} label="Payment screenshot" onOpen={setView} />
            </div>
            <p className="text-[12px] wa-muted mt-3">Approve करने से पहले बैंक/UPI app में UTR और रकम मिला लें।</p>
          </Card>

          <Card title="Personal details" icon="fa-regular fa-id-card">
            <div className="grid sm:grid-cols-2 gap-4">
              <Info label="जन्म तिथि">{m.dob}</Info>
              <Info label="Gender">{m.gender}</Info>
              <Info label="Mobile">{m.phone}</Info>
              <Info label="WhatsApp">{m.whatsapp || "Mobile वाला"}</Info>
              <Info label="पता" full>{m.address}</Info>
              <Info label="District / State">{m.district}, {m.state}</Info>
              <Info label="PIN">{m.pincode}</Info>
            </div>
          </Card>

          <Card title="About" icon="fa-regular fa-user">
            <div className="grid sm:grid-cols-2 gap-4">
              <Info label="काम">{m.profession}</Info>
              <Info label="पढ़ाई">{m.education}</Info>
              <Info label="भाषाएँ">{m.languages}</Info>
              <Info label="रोज़ समय">{m.hoursPerDay}</Info>
              <Info label="Channels / pages" full>{m.channel}</Info>
              <Info label="Experience" full>{m.experience}</Info>
              <Info label="क्यों जुड़ना चाहते हैं" full>{m.whyJoin}</Info>
            </div>
          </Card>

          <Card title="Documents (KYC)" icon="fa-solid fa-shield-halved" actions={<Btn size="sm" icon={showNo ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"} onClick={() => setShowNo(!showNo)}>{showNo ? "छिपाएँ" : "नंबर दिखाएँ"}</Btn>}>
            <div className="grid sm:grid-cols-2 gap-4">
              <Info label="Aadhaar"><span className="font-mono">{mask(m.aadhaarNo, showNo)}</span></Info>
              <Info label="PAN"><span className="font-mono">{m.panNo ? (showNo ? m.panNo : "XXXXX" + m.panNo.slice(5)) : ""}</span></Info>
              <Doc src={m.aadhaarImg} label="Aadhaar card" onOpen={setView} />
              <Doc src={m.panImg} label="PAN card" onOpen={setView} />
            </div>
          </Card>

          {d.history && d.history.length > 0 && (
            <Card title="इसी user की पुरानी applications" icon="fa-solid fa-clock-rotate-left">
              <ul className="text-sm space-y-1">
                {d.history.map((h) => (
                  <li key={h.id} className="flex items-center gap-2"><Badge tone={TONE[h.status] || "gray"}>{h.status}</Badge> {fdate(h.createdAt)} · UTR <span className="font-mono">{h.utr}</span></li>
                ))}
              </ul>
            </Card>
          )}
        </div>
      )}

      {view && (
        <Modal open onClose={() => setView(null)} title={view.label} width={760}>
          <img src={view.src} alt={view.label} className="w-full rounded-xl" />
          <a href={view.src} download={`${(m && m.fullName) || "doc"}-${view.label}.jpg`} className="text-xs underline wa-muted mt-2 inline-block">Download</a>
        </Modal>
      )}
    </Drawer>
  );
}

export default function Managers() {
  const loc = useLocation();
  const qs = new URLSearchParams(loc.search);
  const [status, setStatus] = useState(qs.get("status") || "PENDING");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const [open, setOpen] = useState(qs.get("open") || null);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [status, dq]);
  const { data, loading, error, reload } = useLoad("managers", { status, q: dq, take: TAKE, skip }, [status, dq, skip]);
  const items = (data && data.items) || [];
  const c = (data && data.counts) || {};
  const tabs = TABS.map(([k, l]) => [k, c[k] ? `${l} (${c[k]})` : l]);

  return (
    <div>
      <PageHead
        icon="fa-solid fa-user-shield"
        title="Admin Managers"
        subtitle="Website से आई Admin Manager applications — देखें, approve / reject करें, refund दर्ज करें"
        actions={
          <>
            <Btn icon="fa-solid fa-download" disabled={!items.length} onClick={() => exportCsv(items.map((m) => ({ name: m.fullName, email: m.email, phone: m.phone, district: m.district, state: m.state, amount: m.amount, utr: m.utr, status: m.status, applied: m.createdAt, refund: m.refundRef || "" })), "ycnp-admin-managers")}>CSV</Btn>
            <a href={siteLink("/admin-manager")} target="_blank" rel="noreferrer"><Btn icon="fa-solid fa-arrow-up-right-from-square">Website पर form</Btn></a>
            <Link to="/website/settings?tab=manager"><Btn icon="fa-solid fa-sliders">Fee / settings</Btn></Link>
          </>
        }
      />

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-5">
        <Stat icon="fa-solid fa-hourglass-half" label="Pending" value={num(c.PENDING)} color="#f59e0b" alert={c.PENDING > 0} onClick={() => setStatus("PENDING")} />
        <Stat icon="fa-solid fa-user-check" label="Approved" value={num(c.APPROVED)} color="#10b981" onClick={() => setStatus("APPROVED")} />
        <Stat icon="fa-solid fa-rotate-left" label="Refund बाकी" value={num(c.REJECTED)} color="#ef4444" alert={c.REJECTED > 0} onClick={() => setStatus("REJECTED")} />
        <Stat icon="fa-solid fa-circle-check" label="Refunded" value={num(c.REFUNDED)} color="#0ea5e9" onClick={() => setStatus("REFUNDED")} />
        <Stat icon="fa-solid fa-indian-rupee-sign" label="Approved fee" value={money(data && data.collected)} color="#8b5cf6" />
      </div>

      <div className="flex flex-col gap-3 mb-4">
        <Tabs tabs={tabs} value={status} onChange={setStatus} />
        <Search value={q} onChange={setQ} placeholder="नाम, email, mobile, UTR या district…" />
      </div>

      <ErrorBox msg={error} retry={reload} />
      {loading && !data ? <Skeleton rows={4} h={84} /> : !items.length ? (
        <Card><Empty icon={status === "PENDING" ? "fa-solid fa-check-double" : "fa-solid fa-user-shield"} title={status === "PENDING" ? "कोई नई application नहीं 🎉" : "कुछ नहीं मिला"} text={status === "PENDING" ? "Website पर /admin-manager से applications यहाँ आएँगी।" : ""} /></Card>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className="wa-card wa-in p-4 flex flex-wrap items-center gap-4">
              <Avatar name={m.fullName} size={42} />
              <div className="flex-1 min-w-[220px]">
                <div className="flex flex-wrap items-center gap-2">
                  <button type="button" onClick={() => setOpen(m.id)} className="font-bold hover:underline text-left">{m.fullName}</button>
                  <Badge tone={TONE[m.status] || "gray"}>{LABEL[m.status] || m.status}</Badge>
                </div>
                <p className="text-[12.5px] wa-muted mt-0.5">{m.district}, {m.state} · {m.phone} · {m.email}</p>
                <p className="text-[12.5px] mt-1">
                  {money(m.amount)} · UTR <span className="font-mono select-all">{m.utr}</span>
                  <span className="wa-muted"> · {ago(m.createdAt)}</span>
                </p>
              </div>
              <div className="flex gap-2">
                {wa(m.phone) && <a href={wa(m.phone)} target="_blank" rel="noreferrer" aria-label="WhatsApp"><Btn size="sm" icon="fa-brands fa-whatsapp" /></a>}
                <Btn variant={m.status === "PENDING" ? "primary" : "ghost"} size="sm" icon="fa-regular fa-eye" onClick={() => setOpen(m.id)}>{m.status === "PENDING" ? "Review करें" : "देखें"}</Btn>
              </div>
            </div>
          ))}
          <Card pad={false}><Pager total={data.total} take={TAKE} skip={skip} onChange={setSkip} /></Card>
        </div>
      )}

      {open && <Detail id={open} onClose={() => setOpen(null)} onChanged={reload} />}
    </div>
  );
}
